export default {"src":"/_next/static/media/plus-outline-1.a5305d5e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};